(function () {
  "use strict";

  var t = {
    312: function _(t, e, n) {
      var _r,
          o = this && this.__extends || (_r = function r(t, e) {
        return _r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }
        }, _r(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function n() {
          this.constructor = t;
        }

        _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }),
          i = this && this.__assign || function () {
        return i = Object.assign || function (t) {
          for (var e, n = 1, r = arguments.length; n < r; n++) {
            for (var o in e = arguments[n]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }, i.apply(this, arguments);
      },
          s = this && this.__awaiter || function (t, e, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function s(t) {
            try {
              u(r.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              u(r.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
              t(e);
            })).then(s, a);
          }

          u((r = r.apply(t, e || [])).next());
        });
      },
          a = this && this.__generator || function (t, e) {
        var n,
            r,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                  switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, r = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = e.call(t, s);
                } catch (t) {
                  i = [6, t], r = 0;
                } finally {
                  n = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      },
          u = this && this.__rest || function (t, e) {
        var n = {};

        for (var r in t) {
          Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) {
            e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
          }
        }

        return n;
      },
          c = this && this.__spreadArray || function (t, e, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = e.length; o < i; o++) {
          !r && o in e || (r || (r = Array.prototype.slice.call(e, 0, o)), r[o] = e[o]);
        }
        return t.concat(r || Array.prototype.slice.call(e));
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var l = n(846),
          f = n(574),
          h = n(405),
          p = n(674),
          d = n(64),
          v = n(517),
          y = function (t) {
        function e(e) {
          var n = this,
              r = e.url,
              o = e.network,
              i = e.numberOfBlockConfirmation,
              s = void 0 === i ? 1 : i,
              a = e.defaultFeePerByte,
              u = void 0 === a ? 3 : a;
          return (n = t.call(this, {
            baseURL: r,
            responseType: "text",
            transformResponse: void 0
          }) || this)._network = o, n._numberOfBlockConfirmation = s, n._defaultFeePerByte = u, n._usedAddressCache = {}, n;
        }

        return o(e, t), e.prototype.getFeePerByte = function (t) {
          return void 0 === t && (t = this._numberOfBlockConfirmation), s(this, void 0, void 0, function () {
            var e, n, r;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  return o.trys.push([0, 2,, 3]), [4, this.nodeGet("/fee-estimates")];

                case 1:
                  return e = o.sent(), n = Object.keys(e).map(function (t) {
                    return parseInt(t);
                  }), r = n.reduce(function (e, n) {
                    return Math.abs(e - t) < Math.abs(n - t) ? e : n;
                  }), [2, Math.round(e[r])];

                case 2:
                  return o.sent(), [2, this._defaultFeePerByte];

                case 3:
                  return [2];
              }
            });
          });
        }, e.prototype.getMinRelayFee = function () {
          return s(this, void 0, void 0, function () {
            return a(this, function (t) {
              return [2, 1];
            });
          });
        }, e.prototype.getBalance = function (t) {
          return s(this, void 0, void 0, function () {
            var e, n;
            return a(this, function (r) {
              switch (r.label) {
                case 0:
                  return e = t.map(f.addressToString), [4, this.getUnspentTransactions(e)];

                case 1:
                  return n = r.sent(), [2, (0, v.flatten)(n).reduce(function (t, e) {
                    return t.plus(e.value);
                  }, new d.BigNumber(0))];
              }
            });
          });
        }, e.prototype._getUnspentTransactions = function (t) {
          return s(this, void 0, void 0, function () {
            return a(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.nodeGet("/address/".concat(t, "/utxo"))];

                case 1:
                  return [2, e.sent().map(function (e) {
                    return i(i({}, e), {
                      address: t,
                      value: e.value,
                      blockHeight: e.status.block_height
                    });
                  })];
              }
            });
          });
        }, e.prototype.getUnspentTransactions = function (t) {
          return s(this, void 0, void 0, function () {
            var e,
                n,
                r = this;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  return e = t.map(f.addressToString), [4, Promise.all(e.map(function (t) {
                    return r._getUnspentTransactions(t);
                  }))];

                case 1:
                  return n = o.sent(), [2, (0, v.flatten)(n)];
              }
            });
          });
        }, e.prototype._getAddressTransactionCount = function (t) {
          return s(this, void 0, void 0, function () {
            var e;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.nodeGet("/address/".concat(t))];

                case 1:
                  return [2, (e = n.sent()).chain_stats.tx_count + e.mempool_stats.tx_count];
              }
            });
          });
        }, e.prototype.getAddressTransactionCounts = function (t) {
          return s(this, void 0, void 0, function () {
            var e,
                n,
                r = this;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  return e = t.map(f.addressToString), [4, Promise.all(e.map(function (t) {
                    return s(r, void 0, void 0, function () {
                      var e, n;
                      return a(this, function (r) {
                        switch (r.label) {
                          case 0:
                            return [4, this._getAddressTransactionCount(t)];

                          case 1:
                            return e = r.sent(), [2, (n = {}, n[t] = e, n)];
                        }
                      });
                    });
                  }))];

                case 1:
                  return n = o.sent(), [2, Object.assign.apply(Object, c([{}], n, !1))];
              }
            });
          });
        }, e.prototype.getTransactionHex = function (t) {
          return s(this, void 0, void 0, function () {
            return a(this, function (e) {
              return [2, this.nodeGet("/tx/".concat(t, "/hex"))];
            });
          });
        }, e.prototype.getTransaction = function (t) {
          return s(this, void 0, void 0, function () {
            var e, n, r, o;
            return a(this, function (i) {
              switch (i.label) {
                case 0:
                  return i.trys.push([0, 2,, 3]), [4, this.nodeGet("/tx/".concat(t))];

                case 1:
                  return e = i.sent(), [3, 3];

                case 2:
                  if ("NodeError" === (n = i.sent()).name && n.message.includes("Transaction not found")) throw n.name, n.message, r = u(n, ["name", "message"]), new p.TxNotFoundError("Transaction not found: ".concat(t), r);
                  throw n;

                case 3:
                  return [4, this.getBlockHeight()];

                case 4:
                  return o = i.sent(), [2, this.formatTransaction(e, o)];
              }
            });
          });
        }, e.prototype.formatTransaction = function (t, e) {
          return s(this, void 0, void 0, function () {
            var n, r, o;
            return a(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.getTransactionHex(t.txid)];

                case 1:
                  return n = i.sent(), r = t.status.confirmed ? e - t.status.block_height + 1 : 0, (o = (0, h.decodeRawTransaction)(n, this._network)).confirmations = r, [2, (0, h.normalizeTransactionObject)(o, t.fee, {
                    hash: t.status.block_hash,
                    number: t.status.block_height
                  })];
              }
            });
          });
        }, e.prototype.getBlockByHash = function (t) {
          return s(this, void 0, void 0, function () {
            var e, n, r, o, i, s, c, l, f, h, d;
            return a(this, function (a) {
              switch (a.label) {
                case 0:
                  return a.trys.push([0, 2,, 3]), [4, this.nodeGet("/block/".concat(t))];

                case 1:
                  return e = a.sent(), [3, 3];

                case 2:
                  if ("NodeError" === (n = a.sent()).name && n.message.includes("Block not found")) throw n.name, n.message, r = u(n, ["name", "message"]), new p.BlockNotFoundError("Block not found: ".concat(t), r);
                  throw n;

                case 3:
                  return o = e.id, i = e.height, s = e.timestamp, c = e.mediantime, l = e.size, f = e.previousblockhash, h = e.difficulty, d = e.nonce, [2, {
                    hash: o,
                    number: i,
                    timestamp: c || s,
                    size: l,
                    parentHash: f,
                    difficulty: h,
                    nonce: d
                  }];
              }
            });
          });
        }, e.prototype.getBlockHash = function (t) {
          return s(this, void 0, void 0, function () {
            return a(this, function (e) {
              return [2, this.nodeGet("/block-height/".concat(t))];
            });
          });
        }, e.prototype.getBlockByNumber = function (t) {
          return s(this, void 0, void 0, function () {
            var e;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return e = this.getBlockByHash, [4, this.getBlockHash(t)];

                case 1:
                  return [2, e.apply(this, [n.sent()])];
              }
            });
          });
        }, e.prototype.getBlockHeight = function () {
          return s(this, void 0, void 0, function () {
            var t;
            return a(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.nodeGet("/blocks/tip/height")];

                case 1:
                  return t = e.sent(), [2, parseInt(t)];
              }
            });
          });
        }, e.prototype.getTransactionByHash = function (t) {
          return s(this, void 0, void 0, function () {
            return a(this, function (e) {
              return [2, this.getTransaction(t)];
            });
          });
        }, e.prototype.getRawTransactionByHash = function (t) {
          return s(this, void 0, void 0, function () {
            return a(this, function (e) {
              return [2, this.getTransactionHex(t)];
            });
          });
        }, e.prototype.sendRawTransaction = function (t) {
          return s(this, void 0, void 0, function () {
            return a(this, function (e) {
              return [2, this.nodePost("/tx", t)];
            });
          });
        }, e;
      }(l.NodeProvider);

      e.default = y;
    },
    175: function _(t, e, n) {
      var r = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
        void 0 === r && (r = n);
        var o = Object.getOwnPropertyDescriptor(e, n);
        o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
          enumerable: !0,
          get: function get() {
            return e[n];
          }
        }), Object.defineProperty(t, r, o);
      } : function (t, e, n, r) {
        void 0 === r && (r = n), t[r] = e[n];
      }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
        Object.defineProperty(t, "default", {
          enumerable: !0,
          value: e
        });
      } : function (t, e) {
        t.default = e;
      }),
          i = this && this.__importStar || function (t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var n in t) {
          "default" !== n && Object.prototype.hasOwnProperty.call(t, n) && r(e, t, n);
        }
        return o(e, t), e;
      },
          s = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.esplora = e.BitcoinEsploraApiProvider = void 0;
      var a = s(n(312));
      e.BitcoinEsploraApiProvider = a.default;
      var u = i(n(298));
      e.esplora = u;
    },
    298: function _(t, e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
    },
    405: function _(t) {
      t.exports = require("@yaswap/bitcoin-utils");
    },
    674: function _(t) {
      t.exports = require("@yaswap/errors");
    },
    846: function _(t) {
      t.exports = require("@yaswap/node-provider");
    },
    64: function _(t) {
      t.exports = require("@yaswap/types");
    },
    574: function _(t) {
      t.exports = require("@yaswap/utils");
    },
    517: function _(t) {
      t.exports = require("lodash");
    }
  },
      e = {},
      n = function n(r) {
    var o = e[r];
    if (void 0 !== o) return o.exports;
    var i = e[r] = {
      exports: {}
    };
    return t[r].call(i.exports, i, i.exports, n), i.exports;
  }(175);

  module.exports = n;
})();